import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { ModalOverlay as RACModalOverlay, composeRenderProps } from 'react-aria-components';
import { twMerge } from '../../utils/twMerge.js';
export const ModalOverlay = forwardRef(function Modal(props, forwardedRef) {
    return (_jsx(RACModalOverlay, { ...props, ref: forwardedRef, className: composeRenderProps(props.className, (className) => twMerge('ppl-ModalOverlay fixed inset-0 isolate z-[1000] bg-black/30', 'entering:animate-in entering:fade-in', 'exiting:animate-out exiting:fade-out', className)) }));
});
//# sourceMappingURL=ModalOverlay.js.map